export default __webpack_public_path__ + "static/eve-6eb7da308ee8b701edc668d8a3fa53bb.jpg";